import { ref, type Ref } from 'vue';

/**
 * Config the axios interceptor needs, held outside Pinia.
 *
 * The interceptor cannot import `useAppConfigStore` — the store imports `@/api`,
 * which imports the interceptor — so the appConfig store pushes the handful of
 * values down here as it loads instead.
 */
export const cashierPath: Ref<string> = ref('stripe');

export function setCashierPath(value: string): void {
    cashierPath.value = value;
}
